import { render, staticRenderFns } from "./MasterForm.vue?vue&type=template&id=f747fd18&scoped=true"
import script from "./MasterForm.vue?vue&type=script&lang=js"
export * from "./MasterForm.vue?vue&type=script&lang=js"
import style0 from "./MasterForm.vue?vue&type=style&index=0&id=f747fd18&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f747fd18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f747fd18')) {
      api.createRecord('f747fd18', component.options)
    } else {
      api.reload('f747fd18', component.options)
    }
    module.hot.accept("./MasterForm.vue?vue&type=template&id=f747fd18&scoped=true", function () {
      api.rerender('f747fd18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/Forms/MasterForm.vue"
export default component.exports